import { useMemo, type FC, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

import { MultiChoiceRadio } from "components/Shared";

import "./ChooseYesNoOther.scss";

export interface ChooseYesNoOtherProps {
    label: ReactNode;
    name: string;
    value?: string;
    onChange: (value: string) => void;
    required?: boolean;
    error?: boolean;
    helperText?: ReactNode;
}

export const ChooseYesNoOther: FC<ChooseYesNoOtherProps> = ({ label, name, value = '', onChange, required, error, helperText }) => {
    const { t, ready: translationsReady } = useTranslation('common', { useSuspense: false });

    const options = useMemo(() => [
        { value: 'Y', label: t('yes') },
        { value: 'N', label: t('no') },
        { value: 'O', label: t('other') },
    ], [t, translationsReady]);

    return translationsReady && (
        <FormControl fullWidth error={error} className="ms-choose-yes-no-other">
            <FormControlLabel
                label={<strong>{label}</strong>}
                labelPlacement="top"
                required={required}
                control={
                    <MultiChoiceRadio
                        value={value}
                        onChange={(newValue) => onChange(newValue as string)}
                        name={name}
                        options={options}
                    />
                }
            />
            <FormHelperText>{helperText || ''}</FormHelperText>
        </FormControl>
    );
};
